// extracted by mini-css-extract-plugin
export var statItem = "_i6-1";
export var statsRow = "_i6-0";